import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isAunakProAppRole } from '../constants/aunak-pro-app-roles';
import { getPostLoginRoute } from '../constants/admin-access.constants';
import { AuthSessionService } from '../services/auth-session.service';
import { isMobileAppWebview } from 'src/app/mobile-auth/shared/mobile-webview-session';

/**
 * Only customer / solosp / cprovider may open the Aunak Pro web landing page.
 * Others are sent to their role home.
 * In the mobile OTP webview, send them back to /signin instead of store buttons.
 */
@Injectable({ providedIn: 'root' })
export class AunakProAppLandingGuard implements CanActivate {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    if (isMobileAppWebview()) {
      return this.session.ready().pipe(
        map(() =>
          this.router.createUrlTree(['/signin'], {
            queryParams: { mobile: 'true' },
          }),
        ),
      );
    }
    return this.session.ready().pipe(
      map((profile) => {
        if (!profile || isAunakProAppRole(profile.role)) {
          return true;
        }
        return this.router.createUrlTree([
          getPostLoginRoute(profile.role, profile.isApproved),
        ]);
      }),
    );
  }
}
